export const appOrganizationsInitialState = {
	entities: {},
};

export const appOrganizationInitialState = {
	_id: undefined,
	name: '',
	timezone_locale: '',
	renxt_tenantid: '',
	year_start_from: '',
};



// WEBPACK FOOTER //
// ./src/redux/appOrganizations/appOrganization.initialState.js